import { BdaDataset } from "./BdaDataset";
import { Framework } from "./BdaService";
import { Datasource } from "./Datasource";
import { AccessLevel } from "./generics";
import { Organization, Owner } from "./ControlPanel";

export interface BdaModel {
  accessLevel: AccessLevel;
  algorithmName: string;
  createDateTime: string;
  created: boolean;
  createdByBdaId: number;
  createdByServiceId: number;
  createdByWorkflowId: number;
  datasource: Datasource;
  description: string;
  evaluations: any[];
  format: any;
  framework: Framework;
  id: number;
  inputs: string;
  label: any;
  location: string;
  mlFlowModelUrl: string;
  name: string;
  order: number;
  organization: Organization;
  owner: Owner;
  properties: any[];
  serving: any;
  tags: string[];
  targets: any;
  trainingDataset: BdaDataset;
  updateDateTime: string;
  ref?: string;
}

export class BdaModelDTO {
  id?: number;
  name: string;
  description: string;
  tags: string[];
  format?: string;
  framework?: Framework;
  location?: string;
  datasource?: Datasource;

  constructor() {
    this.name = "";
    this.description = "";
    this.tags = [];
    this.format = "";
  }
}